import React                            from 'react';
import Dialog                           from '@mui/material/Dialog';
import DialogTitle                      from '@mui/material/DialogTitle';
import DialogContent                    from '@mui/material/DialogContent';
import DialogContentText                from '@mui/material/DialogContentText';
import DialogActions                    from '@mui/material/DialogActions';
import Grid                             from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import { connect }                      from 'react-redux';
import DeleteIcon                       from '@mui/icons-material/Delete';
import Typography                       from '@mui/material/Typography';
import { useTranslation }               from 'react-i18next';
import { deleteGalleryImage }           from '../../../store/actions/ArtistAction';
import { ARTIST_GALLERY_IMG_VARIATION } from '../../../store/reducers/ArtistReducer';
import Button from "../inputs/Button";

const useStyles = makeStyles(theme => ({
	imgToInsert: {
		textAlign: 'center'
	},
}));

const DeleteDialog = ({ img, open, setOpen, deleting, artistId, deleteGalleryImage }) => {
	const classes = useStyles();
	const { t } = useTranslation();

	const handleClose = () => {
		setOpen(false);
	};

	const handleDelete = () => {
		deleteGalleryImage(artistId, img.Drive_Item__)
			.then(handleClose);
	};

	return (
        <Dialog
			open={open}
			aria-labelledby='Delete gallery picture'
			aria-describedby='Delete gallery picture'
			fullWidth
		>
            <DialogTitle id='gallery-delete-title'>{t('confirm_delete_picture_title')}</DialogTitle>
            <DialogContent>
				<DialogContentText id='gallery-delete-description'>
					{t('confirm_delete_picture_desc')}
					<br/>
					<Typography variant='body1' color='textPrimary' component='span'>{t('are_you_sure')}</Typography>
				</DialogContentText>
				<Grid container justifyContent='center' alignItems='center' spacing={2}>
					<Grid item xs={12} className={classes.imgToInsert}>
						<img src={img.Media_Image[ARTIST_GALLERY_IMG_VARIATION]} alt={img.Filename}/>
					</Grid>
					<Grid item xs={12}>

					</Grid>

				</Grid>
			</DialogContent>
            <DialogActions>
				<Button variant='contained' color='primary' autoFocus onClick={handleClose} disabled={deleting}>
					{t('back_btn')}
				</Button>
				<Button color='secondary' loading={deleting} disabled={deleting} endIcon={<DeleteIcon/>} onClick={handleDelete}>
					{t('delete_btn')}
				</Button>
			</DialogActions>
        </Dialog>
    );
};

const mapStateToProps = (state) => {
	return {
		deleting: state.artist.deletingImage
	};
};

const mapDispatchToProps = (dispatch, props) => {
	return {
		deleteGalleryImage: (artistId, imgId) => dispatch(deleteGalleryImage(artistId, imgId)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteDialog);
